import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient/supabaseClient";

const SifreGuncelle = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  
  const navigate = useNavigate();

  // Sayfa yüklendiğinde oturum kontrolü (Güvenlik)
  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      // Eğer kullanıcı linke tıklamadan doğrudan bu URL'ye geldiyse oturumu yoktur.
      // Onu giriş sayfasına geri gönderelim.
      if (!session) {
        navigate("/Uyegirisi");
      }
    };
    checkSession();
  }, [navigate]);

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    // 1. Şifrelerin eşleşip eşleşmediğini kontrol et
    if (password !== confirmPassword) {
      setMessage({ type: "danger", text: "Şifreler birbiriyle uyuşmuyor." });
      setLoading(false);
      return;
    }

    // 2. Şifre uzunluk kontrolü (İsteğe bağlı, Supabase min 6 ister)
    if (password.length < 6) {
      setMessage({ type: "danger", text: "Şifreniz en az 6 karakter olmalıdır." });
      setLoading(false);
      return;
    }

    try {
      // 3. Supabase ile şifreyi güncelle
      const { error } = await supabase.auth.updateUser({
        password: password
      });

      if (error) throw error;

      // Başarılı
      setMessage({ type: "success", text: "Şifreniz başarıyla güncellendi! Giriş sayfasına yönlendiriliyorsunuz..." });
      
      // 3 saniye sonra giriş sayfasına at
      setTimeout(() => {
        navigate("/Uyegirisi");
      }, 3000);

    } catch (error) {
      setMessage({ type: "danger", text: "Şifre güncellenirken bir hata oluştu: " + error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ backgroundColor: "#001f3f", color: "white", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", padding: "40px 0", position: "relative" }}>
      {/* Üst Dekoratif Çizgi */}
      <div style={{ width: "100%", height: "10px", backgroundColor: "#8392a1", position: "absolute", top: 0, left: 0 }}></div>
      
      <h2 className="fw-bold mb-4" style={{ color: "#ffffff" }}>Yeni Şifre Belirle</h2>
      
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={4}>
            <Card className="shadow-lg p-4" style={{ backgroundColor: "#8392a1", border: "none", borderRadius: "15px", color: "#001f3f" }}>
              
              {message.text && (
                <Alert variant={message.type} className="text-center" style={{ fontSize: "0.9rem" }}>
                  {message.text}
                </Alert>
              )}
              
              <Form onSubmit={handleUpdatePassword}>
                <Form.Group className="mb-3" controlId="formNewPassword">
                  <Form.Label className="fw-semibold">Yeni Şifre</Form.Label>
                  <Form.Control 
                    type="password" 
                    placeholder="Yeni şifrenizi giriniz" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)} 
                    required 
                    style={{ borderRadius: "10px", border: "1px solid #001f3f" }} 
                  />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formConfirmPassword">
                  <Form.Label className="fw-semibold">Yeni Şifre (Tekrar)</Form.Label>
                  <Form.Control 
                    type="password" 
                    placeholder="Şifrenizi tekrar giriniz" 
                    value={confirmPassword} 
                    onChange={(e) => setConfirmPassword(e.target.value)} 
                    required 
                    style={{ borderRadius: "10px", border: "1px solid #001f3f" }} 
                  />
                </Form.Group>

                <div className="text-center">
                  <Button 
                    type="submit" 
                    disabled={loading} 
                    style={{ backgroundColor: "#001f3f", border: "none", borderRadius: "25px", padding: "10px 40px", fontWeight: "600", minWidth: "150px" }}
                  >
                    {loading ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                        Güncelleniyor...
                      </>
                    ) : (
                      "Şifreyi Güncelle"
                    )}
                  </Button>
                </div>
              </Form>

            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SifreGuncelle;